import { FunctionComponent as F, useEffect, useState } from "react";
import { timestampToSeconds } from "../../utils/string";
import { getTwitterEmbedHtml } from "../../core/http/ref";
import { Box } from "@mui/material";
import SpielsTable from "../Refs/SpielsTable";
import { IValue } from "../Refs/RefsTable";


interface IProps
{
  record: IValue
}

const Twitter: F<IProps> = (props: IProps) =>
{
  const [html, setHtml] = useState("");

  useEffect(() =>
  {
    getTwitterEmbedHtml(props.record.url, 'video')
      .then(resHtml =>
      {
        setHtml(resHtml);

        setTimeout(() =>
        {
          const script = document.createElement("script");
          script.src = "https://platform.twitter.com/widgets.js";
          document.getElementsByClassName("twitter-video")[0].appendChild(script);
        }, 500);
      })
  }, []);

  const timestampUrl = (timestamp: string) => props.record.mediaId + "?t=" + timestampToSeconds(timestamp) + "s";

  const onTimestampClick = (timestamp: string) =>
    window.open(timestampUrl(timestamp), '_blank', 'noopener,noreferrer');

  return(
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ display: 'flex' }}>
        <SpielsTable
          record={props.record}
          onTimestampClick={onTimestampClick}
          timestampTooltip={timestampUrl}/>
      </Box>
      <Box sx={{ display: 'flex', width: 400 }} dangerouslySetInnerHTML={{ __html: html }} />
    </Box>);
};

export default Twitter;

